import Tooltip from 'components/Tooltip/Tooltip'

export default Tooltip
